<template>
  <div class="popup popup-researchGroupMember">
    <div class="hd research-background-color">
      <div class="outer">
        <span class="header_title">课题组成员搜索</span>
        <svg class="arrow_down close-popup" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
      </div>
      <div class="block_input">
        <div class="wrap" @click="autofocus">
          <label class="icon icon-search icon_2" for="search"></label>
          <input class="icon_2" v-model.trim="query" type="search" id='search' placeholder=''/>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="outer_3">
        <div class="outer_attr" v-for="(member, index) in filteredData" :key="index">
          <div class="group close-popup" @click="updateChosenResearchMember(member)">
            <img class="avator" src="/static/img/avator2.png"/>
            <div class="attr_name">{{member.memberName}}</div>
            <div class="block">
              <!-- <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg> -->
            </div>
          </div>
          <div class="container"><div class="empty" /></div> 
        </div>
      </div>       
    </div> 
  </div>
</template>
<script>
import {mapGetters, mapState, mapMutations} from 'vuex'
import $ from 'jquery'
// import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      query: '',
      data: [],
      filteredData: []
    }
  },
  mounted () {
    let researchGroupMember = $('.popup-researchGroupMember')
    researchGroupMember.on('open', () => {
      console.log('popup is opening')
      this.query = ''
      this.fetchData()
    })
    researchGroupMember.on('closed', () => {
      console.log('popup closed')
    })
  },
  watch: {
    // listening to input
    'query': function (query) {
      console.log('in query')
      this.initialize()
      let data = this.data
      let filteredData = []
      for (let member of data) {
        if (member.memberName.match(query.toLowerCase())) {
          filteredData.push(member)
          if (filteredData.length > 19) {
            break
          }
        }
      }
      this.filteredData = filteredData
    }
  },
  computed: {
    ...mapState([
      'researchGroupMemberMap'
    ]),
    ...mapGetters([
      'displayChosenResearchGroup'
    ])
  },
  methods: {
    ...mapMutations([
      'UPDATE_CHOSEN_RESEARCH_MEMBER'
    ]),
    goBack () {
      this.$router.go(-1)
    },
    updateChosenResearchMember (member) {
      this.UPDATE_CHOSEN_RESEARCH_MEMBER(member)
    },
    fetchData () {
      // 获取课题组成员列表
      if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return
      if (!this.researchGroupMemberMap || JSON.stringify(this.researchGroupMemberMap) === '{}') return
      const researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
      this.data = this.researchGroupMemberMap[researchGroupNo]
      this.initialize()
    },
    initialize () {
      this.filteredData = this.data
    },
    autofocus () {
      $('#search').focus()
    }
  }
}
</script>
<style scoped>
.box {
  /*display: flex;*/
  position: relative;
  /*align-items: center;*/
  /*flex-direction: column;*/
  background-color: #ffffff;
  width: 100vw;
  /*height: 100vh;*/
  /*top: 29.87vw;*/
  overflow: scroll;
}
.arrow_down {
  margin-left: 22vw;
  /* width: 2.67vw;
  height: 1.73vw; */
}

.hd {
  display: flex;
  /*position: fixed;*/
  /*top:0;*/
  /*left:0;*/
  align-items: flex-start;
  flex-direction: column;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 29.87vw;
  z-index: 10;
}
.outer {
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 16vw;
}
.header_title {
  opacity: 1;
  margin-left: 35.2vw;
  max-width: 33.07vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.outer_3 {
  /*display: flex;*/
  /*align-items: flex-start;*/
  /*flex-direction: column;*/
  /*justify-content: center;*/
  background-color: #ffffff;
  width: 100vw;
  padding: 2vw 0;
}
.avator {
  margin-left: 2vw;
  width: 12vw;
  height: 12vw;
  border-radius: 11vw;
}
.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 100vw;
}
/* .outer_3 .outer_attr:last-child .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
} */

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 93vw;
  height: 0.53vw;
}
.icon_2 {
  margin-left: 3.73vw;
  outline: none;
  border: none;
  /* width: 3.73vw;
  height: 3.73vw; */
}
.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* margin-top: 3.47vw; */
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 100vw;
  align-items: center;
  height: 16vw;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: bold;
  margin-left: 4vw;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  /* margin-top: 4vw; */
  width: 100vw;
}

.block {
  display: flex;
  align-items: center;
  flex-direction: row;
  /* width: 26.4vw; */
  height: 5.33vw;
}
.block_input {
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* margin-top: 5.87vw; */
  width: 99.73vw;
}

.wrap {
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  height: 9.33vw;
}

.icon-search:before {
    font-weight: bold;
    color: #929292;
}
</style>



// WEBPACK FOOTER //
// ResearchGroupMemberBox.vue?ec969aa6